/* Scoped navigation. Custom-element lifecycle also covers theme-editor replacement. */
if (!customElements.get('ic-product-navigation')) {
  customElements.define('ic-product-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('load', this.schedule, { signal });
      ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => {
        document.addEventListener(event, this.schedule, { signal });
      });
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        const target = link && document.getElementById(link.hash.slice(1));
        if (!target) return;
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        // Native anchors keep URL history and work without JavaScript.
      }, { signal });
      this.schedule();
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    update() {
      const entries = [...this.querySelectorAll('a[href^="#"]')].map(link => {
        const target = document.getElementById(link.hash.slice(1));
        link.hidden = !target || !target.getClientRects().length;
        return { link, target };
      }).filter(entry => !entry.link.hidden);
      this.hidden = !entries.length;
      let active = entries[0]?.link;
      const line = Math.max(140, parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0) + 20;
      for (const { link, target } of entries) {
        if (target.getBoundingClientRect().top <= line) active = link;
      }
      for (const { link } of entries) {
        if (link === active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
    }
  });
}
